export default __webpack_public_path__ + "static/media/PACQR.9b52e94c.png";